import React, { useState } from 'react';
import axios from 'axios';
import { debugAuth, clearAuth, testAuthHeader } from '../utils/authDebug';

const AuthTest = () => {
    const [result, setResult] = useState('');
    const [loading, setLoading] = useState(false);

    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

    const testHealthCheck = async () => {
        setLoading(true);
        try {
            const response = await axios.get('http://localhost:5000/health');
            setResult(JSON.stringify(response.data, null, 2));
            console.log('✅ Health check:', response.data);
        } catch (error) {
            setResult(`Error: ${error.message}`);
            console.error('❌ Health check failed:', error);
        } finally {
            setLoading(false);
        }
    };

    const testLogin = async () => {
        setLoading(true);
        try {
            const response = await axios.post(`${API_URL}/auth/login`, {
                email: 'admin@b2bmarketplace.com',
                password: 'admin123'
            });

            console.log('✅ Login response:', response.data);

            if (response.data.success) {
                const { token, user } = response.data.data;
                localStorage.setItem('adminToken', token);
                localStorage.setItem('adminUser', JSON.stringify(user));
                setResult(JSON.stringify(response.data, null, 2));
                debugAuth();
            }
        } catch (error) {
            setResult(`Error: ${error.response?.data?.message || error.message}`);
            console.error('❌ Login failed:', error.response?.data || error);
        } finally {
            setLoading(false);
        }
    };

    const testProtectedRoute = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('adminToken');
            const response = await axios.get(`${API_URL}/auth/profile`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setResult(JSON.stringify(response.data, null, 2));
            console.log('✅ Profile:', response.data);
        } catch (error) {
            setResult(`Error: ${error.response?.data?.message || error.message}`);
            console.error('❌ Profile failed:', error.response?.data || error);
        } finally {
            setLoading(false);
        }
    };

    const testAdminRoute = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('adminToken');
            const response = await axios.get(`${API_URL}/admin/buyers`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setResult(JSON.stringify(response.data, null, 2));
            console.log('✅ Admin route:', response.data);
        } catch (error) {
            setResult(`Error: ${error.response?.data?.message || error.message}`);
            console.error('❌ Admin route failed:', error.response?.data || error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
            <h1>Auth Diagnostic Tool</h1>

            <div style={{ marginBottom: '20px' }}>
                <h3>Debug Actions</h3>
                <button onClick={() => debugAuth()} style={{ margin: '5px' }}>
                    Debug Auth State
                </button>
                <button onClick={() => clearAuth()} style={{ margin: '5px' }}>
                    Clear Auth Data
                </button>
                <button onClick={() => testAuthHeader()} style={{ margin: '5px' }}>
                    Test Auth Header
                </button>
            </div>

            <div style={{ marginBottom: '20px' }}>
                <h3>API Tests</h3>
                <button onClick={testHealthCheck} disabled={loading} style={{ margin: '5px' }}>
                    Test Health Check
                </button>
                <button onClick={testLogin} disabled={loading} style={{ margin: '5px' }}>
                    Test Login (admin@example.com)
                </button>
                <button onClick={testProtectedRoute} disabled={loading} style={{ margin: '5px' }}>
                    Test Protected Route
                </button>
                <button onClick={testAdminRoute} disabled={loading} style={{ margin: '5px' }}>
                    Test Admin Route
                </button>
            </div>

            <div style={{ marginTop: '20px' }}>
                <h3>Result:</h3>
                <pre style={{
                    background: '#f5f5f5',
                    padding: '15px',
                    borderRadius: '5px',
                    overflow: 'auto',
                    maxHeight: '400px'
                }}>
                    {result || 'No result yet. Click a button to test.'}
                </pre>
            </div>

            <div style={{ marginTop: '20px', padding: '15px', background: '#fff3cd', borderRadius: '5px' }}>
                <h4>Instructions:</h4>
                <ol>
                    <li>Open browser console (F12)</li>
                    <li>Click "Test Health Check" to verify backend is running</li>
                    <li>Click "Test Login" to login and store token</li>
                    <li>Click "Debug Auth State" to verify token is stored</li>
                    <li>Click "Test Protected Route" to test authentication</li>
                    <li>Click "Test Admin Route" to test authorization</li>
                </ol>
            </div>
        </div>
    );
};

export default AuthTest;
